import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import horizontalLoop from "@js/utils/gsapHorizontalLoop";

gsap.registerPlugin(ScrollTrigger);

function cloneHTMLElement(item, n = 2, parent = null) {
  if (parent == null) parent = item.parentNode;

  Array.from({ length: n }).forEach(() => parent.append(item.cloneNode(true)));
}

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll("[data-gsap-h-gallery]");

  blocks.forEach((block) => {
    const trigger = block.querySelector("[data-gsap-h-gallery-trigger]");
    const trail = trigger.querySelector(":first-child");
    const cloneItem = trail.querySelector(":first-child");
    // create 2 more cloneItem html elements to create a loop effect
    cloneHTMLElement(cloneItem, 2, trail);

    const scrollingItem = gsap.utils.toArray(trail.children);

    const tl = horizontalLoop(scrollingItem, {
      repeat: -1,
    });

    let speedTween;

    const scrollTrigger = ScrollTrigger.create({
      trigger,
      start: "top bottom",
      end: "bottom top",
      onUpdate: (self) => {
        speedTween && speedTween.kill();
        speedTween = gsap
          .timeline()
          .to(tl, {
            timeScale: 2.5 * self.direction,
            duration: 0.25,
          })
          .to(
            tl,
            {
              timeScale: 0.5 * self.direction,
              duration: 1.5,
            },
            "<"
          );
      },
    });    
  });
});
